import request from '@/utils/request'

export function mmsActivityTagHotList (parameter) {
  return request({
    url: '/activity/tag/mms/hot/list',
    method: 'post',
    data: parameter
  })
}

export function mmsActivityTagSetList (parameter) {
  return request({
    url: '/activity/tag/mms/list',
    method: 'post',
    data: parameter
  })
}

export function activityTemplateSkinPagelist (parameter) {
  return request({
    url: '/activity/templateskin/mms/pagelist',
    method: 'post',
    data: Object.assign({}, parameter)
  })
}